module.exports = __webpack_public_path__ + "img/SDG-01-EN-INVERTED.6b4402a5.png";